import { z } from "zod";

export const loginSchema = z.object({
	email: z.email({ message: "E-mail inválido" }),
	password: z.string().min(3, "Senha precisa ter no mínimo 3 caracteres"),
});
